module.exports = __webpack_public_path__ + "img/game-logo.3809eef.png";